'use strict';
import angular from 'angular';
import './scripts/lookup.ctrls';

import lookupTypesHtmlUrl from './views/lookupTypes.html';
import lookupContentsHtmlUrl from './views/lookupContents.html';

angular.module('lookup', [
    'lookup.ctrls'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('lookupTypes', {
                parent: 'layout',
                url: '/admin/lookupTypes',
                templateUrl: lookupTypesHtmlUrl,
                controller: 'LookupTypesController',
            })
            .state('lookupContents', {
                parent: 'layout',
                url: '/admin/lookupContents/:typeId/:parentLookupTypeId/:contentKey',
                templateUrl: lookupContentsHtmlUrl,
                controller: 'LookupContentController',
            })
    }]);